<script setup lang="ts">
import { onMounted } from 'vue';
import { ToastManager } from '@skillstown/leap';

onMounted(() => {
  document.documentElement.setAttribute('lang', navigator.language.slice(0, 2));
});
</script>

<template>
  <router-view />
  <ToastManager />
</template>

<style lang="scss">
:root {
  --100vh: 100dvh;
  --ui-color: var(--color-grey-medium);
}

#app {
  min-height: var(--100vh, 100vh);
  background-color: var(--color-body-bg);
}

.modal__footer .button-size--l {
  @media (min-width: 768px) {
    min-width: var(--size-5xl);
  }
}
</style>
